import { FormSection } from '@state/form/form.model';
import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

import { SectionComponent } from '@app/shared/components/rendered-form/section/section.component';

export interface FormValues {
  [key: string]: string | number;
}
export interface FormWizardState {
  activeIndex?: { position: number };
  activeSection?: FormSection;
  activeSectionFormValues?: FormValues;
  showWarningOnUpdate?: boolean;
  isSubmitting?: boolean;
  updatedFormValues?: FormValues;
  visibleSections: FormSection[];
}

export interface SubmitEvent {
  activeSectionFormValues?: FormValues;
  updatedFormValues?: FormValues;
}

export interface NextEvent extends SubmitEvent {
  currentSection?: SectionComponent;
  fromFormLayout?: boolean;
  initialForm?: FormValues;
  showProgress?: boolean;
  sectionIndex?: number;
  skipSave?: boolean;
}

function createInitialState(): FormWizardState {
  return {
    activeIndex: undefined,
    activeSection: undefined,
    activeSectionFormValues: undefined,
    showWarningOnUpdate: false,
    updatedFormValues: undefined,
    visibleSections: []
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'form-wizard', resettable: true })
export class FormWizardStore extends Store<FormWizardState> {
  constructor() {
    super(createInitialState());
  }
}
